import React, { Component, Suspense } from 'react';
import Draggable, { DraggableCore } from "react-draggable";
import { Dropdown, ErrorBoundary } from '../components/elemans/_elemans';
import { Template1, Template2, Template3, Template4 } from '../components/_index';
import { Switch } from '../components/elemans/_elemans';
import { Login } from '../components/Login';
import { FeedBack } from '../components/FeedBack';
import { SaveDialog } from '../components/SaveDialog';
import Helper from '../services/Helper'
import { consts, icons } from '../services/_consts';
import { t, lang } from '../services/_lang';
import { cvFarsi, cvEng, myCv } from '../services/_templateData';
import CvMakerContext from '../services/app-context';
import { MainToolbar } from '../components/MainToolbar';
import 'intro.js/introjs.css';
import { Steps, Hints } from 'intro.js-react';
//const Template1 = React.lazy(() => import('../themes/_index'));
//const Template2 = React.lazy(() => import('./themes/_index'));
//const Template3 = React.lazy(() => import('./themes/_index'));
const steps = [
    {
        title: 'Welcome to iResume',
        intro: "<p class=''>make your professional resume in minutes and share it</p>"
    },
    {
        element: '.selector1',
        title: 'toolbar',
        intro: 'here is toolbar main menu.where you can save,open,share,print,... your Resume',
        position: 'right',
        tooltipClass: 'myTooltipClass',
        highlightClass: 'myHighlightClass',
    },
    {
        element: '.user-btn',
        title: 'sign in',
        intro: 'access to your saved resumes, sign in/sign up',
    },
    {
        element: '.selector2',
        title: 'add items to resume',
        intro: 'you can choose what kind of information you want to have in your Resume.informations such as Skills,work expreince,... ',
    },
    {
        element: '.lang-div',
        title: 'app language',
        intro: 'change language of program. for now just english and farsi is supported',
        position: 'left',
    },
    {
        element: '.setting-div-btn',
        title: 'setting',
        intro: 'change resume template,rtl resume and other setting of Resume is here',
        position: 'left',
    }
];
export default class Home extends Component {
    static displayName = Home.name;
    static contextType = CvMakerContext;

    templates = [
        { id: 1, title: 'default', avatar: 'Template1.png', theme: Template1 },
        { id: 2, title: 'green sidebar', avatar: 'Template2.png', theme: Template2 },
        { id: 3, title: 'black & white', avatar: 'Template3.png', theme: Template3 },
        { id: 4, title: 'black & white2', avatar: 'Template4.png', theme: Template4 }];
    style = {
        menu: {
            position: 'absolute',
            padding: '0px 0',
            background: 'white',
            borderRadius: '10px',
            border: '1px solid #c8c8c8',
            overflow: 'hidden',
            marginLeft: '-50px',
            marginTop: '6px',
            boxShadow: '0 5px 10px rgba(0, 0, 0, 0.2)'
        },
        las: {
            // background: 'gray',
            // padding: '3px',
            borderRadius: '5px',
            color: 'black',
            margin: '0 4px',
            fontSize: '24px'
        }
    };

                            
    templateProp = {};                                       

    constructor(props) {
        super(props);
        this.state = {
            contenteditableIsFocused: true,
            openUserMenu: false,
            menu1: false,
            openLoginModal: false,
            openFeedBackModal:false,
            openSetting: false,
            loadingResume: false,
            myResumes: [],
            zoom: 100,
            templateIndex: 1,
            selectedTemplate : Template1,
            title: '',
            cv: cvEng
        };

        this.templateProp = {
            ref: e => this.cvTemp = e ,
            handleChange: this.handleChange,
            onRatechange: this.onRatechange,
            onContentChanged: this.onContentEditableChange,
            onContentEditedInList: this.onContentEditedInList,
            onRemoveFromList: this.onRemoveFromList,
            onMoveInList: this.onMoveInList,
        }
    }

    componentDidMount() {
        window.addEventListener('click', this.onClickOutsideHandler);
        window.addEventListener("keydown", this.onKeyPressed);

        if (this.context.getCurrentUser()) {
            this.myResumesAsync();
        }

        Helper.callApiAsJson({
            url: 'resume/Version', type: 'get'
        });

    }

    componentWillUnmount() {
        window.removeEventListener('click', this.onClickOutsideHandler);
        window.removeEventListener("keydown", this.onKeyPressed);
    }

    onKeyPressed = (e) => {
        if (e.ctrlKey && e.key === 's') {
            e.preventDefault();
            this.setState({ openSaveModal: true });
        }
    }

    onClickOutsideHandler = (event) => {
        if (this.state.menu1 && !this.toggleContainer.contains(event.target)) {
            this.setState({ menu1: false });
        }
        if (this.state.openUserMenu && this.userMenuContainer && !this.userMenuContainer.contains(event.target)) {
            this.setState({ openUserMenu: false });
        }
    }

    printCv = () => {
        //document.getElementById('toollbar').classList.add('d-none');
        window.print()
        //document.getElementById('toollbar').classList.remove('d-none');

        //var divContents = document.getElementById("GFG").innerHTML;
        //var head = document.getElementsByTagName('head')[0].innerHTML;
        //debugger;
        //var a = window.open('', '', 'height=500, width=500');
        //a.document.write('<html>');
        //a.document.write('<head>' + head + '<style></style>' + '</head>');
        //a.document.write('<body >');
        //a.document.write(divContents);
        //a.document.write('</body></html>');
        //a.document.close();
        //a.print();
    }

    saveCv = () => {
        let filename = this.state.cv.fullName + ".iResume";
        let text = Helper.encorypt({ cv: this.state.cv, templateIndex: this.state.templateIndex });


        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
        this.setState({ openLoginModal: false });
    }

    newCv = (cv) => {
        let t = this.state.templateIndex;
        this.setState({ templateIndex: 0 }, () => {
            this.setState({
                templateIndex: t,
                title: '',
                cv: cv
            }, () => { this.setTemplate(); });
        });
        //debugger
        document.title = 'iResume';
        this.newDropdown?.close();
    }

    saveToServer = async (title) => {

        let text = Helper.encorypt({ cv: this.state.cv, templateIndex: this.state.templateIndex });

        const data = await Helper.callApiAsJson({
            url: 'resume/SaveResume', type: 'post',
            data: { resumeEnc: text, id: this.state.cv.id, title }
        })

        if (data && data.id) {
            this.setState({ openSaveModal: false, cv: { ...this.state.cv, id: data.id } });
            document.title = this.state.cv.fullName + '';
        }

        await this.myResumesAsync();
    }

    myResumesAsync = async () => {
        //const data = await Helper.callApiAsJson({
        //    url: 'resume/myResumes', type: 'get',
        //})
        const data = await fetch('resume/myResumes', {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": 'bearer ' + localStorage.getItem('token')
            },
        })
            .then(data => {

                if (data.status == 401) {

                    this.context.signOut();
                }
                return data.json();
            })
            .catch((response) => { });
        if (data) {
            this.setState({ openLoginModal: false, myResumes: data });
        }
    }

    openResume = async (id) => {
        this.setState({
            openUserMenu: false,
            loadingResume: true
        });
        const data = await Helper.callApiAsJson({
            url: 'resume/Resume', type: 'post', data: { id }
        })

        if (data) {
            let resume = Helper.decode(data.text);

            this.setState({ templateIndex: 0 }, () => {
                this.setState({
                    openUserMenu: false,
                    loadingResume: false,
                    templateIndex: resume.template,
                    title: data.title,
                    cv: { ...resume.cv, id: id }
                }, () => { this.setTemplate(); });

                document.title = resume.cv.fullName + '';
            });
        }
    }

    removeResume = async (id) => {
        //if (! confirm("are you sure?")) return;

        const data = await Helper.callApiAsJson({
            url: 'resume/removeResume', type: 'post', data: { id }
        })

        if (data) {
            debugger;
            var myResumes = this.state.myResumes.filter(x => x.id != id);
            this.setState({ myResumes: myResumes })
        }
    }

    translate = async (textToTranslate) => {

        const options = {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'X-RapidAPI-Key': 'd710e0481bmsh3bab865b0e2ce1ep1a5f0cjsn0382cd7aaeda',
                'X-RapidAPI-Host': 'microsoft-translator-text.p.rapidapi.com'
            },
            body: '[{"Text":"How are you? I am fine. What did you do today?"}]'
        };

        fetch('https://microsoft-translator-text.p.rapidapi.com/BreakSentence?api-version=3.0', options)
            .then(response => response.json())
            .then(response => console.log(response))
            .catch(err => console.error(err));

    }

    onFileSelecting = (evt) => {
        var files = evt.target.files;
        for (var i = 0, f; f = files[i]; i++) {
            var reader = new FileReader();
            reader.onload = ((theFile) => {
                return (e) => {
                    var content = e.target.result;
                    if (content) {
                        // Decrypt
                        var obj = Helper.decode(content);

                        this.setState({ templateIndex: 0 }, () => {
                            this.setState({ templateIndex: obj.template, cv: obj.cv }, () => { this.setTemplate(); });
                        });

                    }
                };
            })(f);

            reader.readAsText(f);
        }
    }

    handleChange = (field, value) => {
        this.setState({ cv: { ...this.state.cv, [field]: value } });
    }

    addNewItem = (field) => {

        this.setState({ menu1: false });

        let oldLength = this.cvTemp.state[field].length;
        let obj = consts[field + "Temp"];
        this.cvTemp.setState({ [field]: [...this.cvTemp.state[field], obj] }, () => {
            let id = field + '' + (oldLength);
            this.scrollTo(id);
        });


    }

    scrollTo = (id) => {
        const section = document.querySelector('#' + id);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'center' });
            section.focus();
            section.classList.add('shake2');
        }
    };

    onContentEditableChange = (e, field) => {

        let newValue = '';
        if (e.target.type == 'checkbox') {
            newValue = e.target.checked;
        }
        else if (e.target.type == 'color') {
            newValue = e.currentTarget.value;
        }
        else {
            newValue = e.currentTarget.textContent;
        }

        // this.cvTemp.setState({ [field]: newValue }, () => {
        //     //this.setState({ cv: { ...this.state.cv, [field]: newValue } });
        //     this.handleChange(field, newValue);
        // });
        this.cvTemp.setState({ [field]: newValue });
        this.handleChange(field, newValue);
    }

    onContentEditedInList = (e, field, i, innerField) => {
        let lst = this.cvTemp.state[field];
        let newValue = e.currentTarget.textContent;

        if (!innerField) {
            if (lst[i] != newValue) {
                lst[i] = newValue;

                this.cvTemp.setState({ [field]: lst }, () => {
                    this.handleChange(field, this.cvTemp.state[field]);
                });
            }
        }
        else {
            if (lst[i][innerField] != newValue) {
                debugger
                lst[i][innerField] = newValue;

                this.cvTemp.setState({ [field]: lst }, () => {
                    this.handleChange(field, this.cvTemp.state[field]);
                });
            }
        }
    }

    onRatechange = (e, field, i, r) => {

        let lst = this.cvTemp.state[field];
        lst[i]['rateOf10'] = r;
        this.cvTemp.setState({ [field]: lst }, () => {
            this.handleChange(field, this.cvTemp.state[field]);
        });
    }

    onRemoveFromList = (field, i) => {
        let lst = this.cvTemp.state[field];

        if (lst.constructor.name == "Array") {
            lst.splice(i, 1);

            this.cvTemp.setState({ [field]: lst }, () => {
                this.handleChange(field, this.cvTemp.state[field]);
            });
        }
        else {
            debugger
            this.cvTemp.setState({ [field]: false }, () => {
                this.handleChange(field, this.cvTemp.state[field]);
            });
        }
    }

    onMoveInList = (field, i, dir) => {
        let lst = this.cvTemp.state[field];

        if (lst.constructor.name == "Array") {
            if ((dir == 'up' && i > 0) || (dir == 'down' && i < lst.length - 1)) {
                let lst2 = [];
                if (dir == 'up' && i > 0) {
                    for (var j = 0; j < i - 1; j++) lst2.push(lst[j]);
                    lst2.push(lst[i]);
                    lst2.push(lst[i - 1]);
                    for (var j = i + 1; j < lst.length; j++) lst2.push(lst[j]);
                }
                if (dir == 'down' && i < lst.length - 1) {
                    debugger
                    for (var j = 0; j < i; j++) lst2.push(lst[j]);
                    lst2.push(lst[i + 1]);
                    lst2.push(lst[i]);
                    for (var j = i + 2; j < lst.length; j++) lst2.push(lst[j]);
                }

                this.cvTemp.setState({ [field]: lst2 }, () => {
                    this.handleChange(field, this.cvTemp.state[field]);
                });
            }
        }
    }

    setToDefaultColor = () => {
        this.cvTemp.setState({ 'color2': this.cvTemp.defaultColor });
        this.handleChange('color2', this.cvTemp.defaultColor);
    }

    signOut = () => {
        this.context.signOut();
        this.newCv(cvEng);
    }

    setTemplate = () => {
        let template = Template1;
        if (this.state.templateIndex == 2) template = Template2;
        else if (this.state.templateIndex == 3) template = Template3;
        else if (this.state.templateIndex == 4) template = Template4;

        this.setState({ selectedTemplate: template }, () => {
            this.cvTemp.setState({ 'color2': this.cvTemp.defaultColor });
            this.handleChange('color2', this.cvTemp.defaultColor);
        });
    }

    render() {
        return (
            <div className="bg-div" style={{ backgroundColor: '#e5e5f7', minHeight: '100vh' }} >


                <Steps
                    enabled={localStorage.getItem("tourDone") != "true"}
                    steps={steps}
                    initialStep={0}
                    onComplete={() => { localStorage.setItem("tourDone", "true"); }}
                    onExit={() => { }}
                />

                {/*<MainToolbar />*/}
                <div id="toollbar" className={`${this.context.lang.rtl ? 'rtl aviny' : 'ltr'} noPrint ng-white navbar headcolor`}
                    style={{ direction: 'ltr', position: 'sticky', top: '-1px', zIndex: '3', padding: '3px 12px', borderBottom: '1px solid #cccbcb', backdropFilter: 'blur(6px)' }} >
                    <div className="selector1">


                        <Dropdown ref={e => this.fileDropdown = e}
                            title={<><span className="d-none d-sm-inline">  {t("file")}</span></>}
                            className="btn btn-outline-dark btn-sm me-1 bg-white2 "
                            style={{ left: '45px', width:'180px' }} >
                            {this.state.cv && this.state.cv.id ?
                                <button onClick={() => { window.open(`cv2/${this.state.cv.id}/${this.state.cv.fullName.replace(" ", "-")}`, '_blank').focus(); }} className="btn btn-link text-start"><i className="las la-share-alt-square float-start" style={this.style.las}></i>{t("share")}</button> : <></>
                            }


                            <button onClick={() => document.getElementById('cvFile').click()} className="btn btn-link text-start"><i className="las la-folder-open float-start" style={this.style.las}></i>{t("open")}</button>
                            <input onChange={(e) => { this.onFileSelecting(e) }} accept=".iResume" type="file" id="cvFile" className='d-none' />

                            <button onClick={() => { this.setState({ openSaveModal: true }); }} className="btn btn-link text-start"><i className={`${icons.save} float-start`} style={this.style.las}></i>{t("save")}</button> 

                            <hr className="m-0" />
                            <button onClick={() => this.newCv(cvEng)} className="btn btn-link text-start"><i className="las la-file float-start" style={this.style.las}></i>New English CV</button>
                            <button onClick={() => this.newCv(cvFarsi)} className="btn btn-link text-start"><i className="las la-file float-start" style={this.style.las}></i>رزومه فارسی جدید</button>
                            <hr className="m-0" />
                            <button onClick={() => { this.printCv() }} className="btn btn-link text-start"> <i className="las la-print float-start" style={this.style.las}></i>{t("print")}</button>

                        </Dropdown>


                        <Dropdown ref={e => this.toggleContainer = e}
                            title={<span className="d-none d-sm-inline">  {t("item")}<i className="las la-plus"></i></span>}
                            className="btn btn-outline-dark btn-sm me-1 bg-white2 "
                            style={{ left: '45px', width: '252px' }} >
                            <button onClick={() => this.addNewItem('educations')} className="btn btn-link text-start"><i className="las la-graduation-cap float-start" style={this.style.las}></i>{this.context.lang.education}</button>
                            <button onClick={() => this.addNewItem('skills')} className="btn btn-link text-start"><i className="las la-thumbs-up float-start" style={this.style.las}></i>{this.context.lang.skill}</button>
                            <button onClick={() => this.addNewItem('workExperinces')} className="btn btn-link text-start"><i className="las la-tasks float-start" style={this.style.las}></i>{this.context.lang.workExperince}</button>
                            <button onClick={() => this.addNewItem('languages')} className="btn btn-link text-start"><i className="las la-globe float-start" style={this.style.las}></i>{this.context.lang.language}</button>
                            <button onClick={() => this.addNewItem('freelanceProjects')} className="btn btn-link text-start"><i className="lab la-product-hunt float-start" style={this.style.las}></i>{this.context.lang.freelanceProject}</button>
                            <button onClick={() => this.addNewItem('certificates')} className="btn btn-link text-start"><i className="las la-certificate float-start" style={this.style.las}></i>{this.context.lang.certificate}</button>
                            <hr style={{ margin: '0.1rem 0' }} />
                            <div className="btn btn-link text-start">
                                <Switch text={this.context.lang.avatar}
                                    icon={<i class="las la-user-circle"></i>}
                                    defaultChecked={this.state.cv.showAvatar}
                                    onChange={e => this.onContentEditableChange(e, 'showAvatar')} />
                            </div>

                            <div className="btn btn-link text-start">
                                <Switch text={this.context.lang.birthDate}
                                    icon={<i class="las la-birthday-cake"></i>}
                                    defaultChecked={this.state.cv.showBirthDate}
                                    onChange={e => this.onContentEditableChange(e, 'showBirthDate')} />
                            </div>

                            <div className="btn btn-link text-start">
                                <Switch text={this.context.lang.smallDesc}
                                    defaultChecked={this.state.cv.showMySmallDesc}
                                    onChange={e => this.onContentEditableChange(e, 'showMySmallDesc')} />
                            </div>

                            <div className="btn btn-link text-start">
                                <Switch text={this.context.lang.site}
                                    icon={<i class="las la-link"></i>}
                                    defaultChecked={this.state.cv.showSite}
                                    onChange={e => this.onContentEditableChange(e, 'showSite')} />
                            </div>

                            <div className="btn btn-link text-start">
                                <Switch text={this.context.lang.github}
                                    icon={<i class="lab la-github"></i>}
                                    defaultChecked={this.state.cv.showGithub}
                                    onChange={e => this.onContentEditableChange(e, 'showGithub')} />
                            </div>

                            <div className="btn btn-link text-start">
                                <Switch text={this.context.lang.linkedin}
                                    icon={<i class="lab la-linkedin"></i>}
                                    defaultChecked={this.state.cv.showLinkedIn}
                                    onChange={e => this.onContentEditableChange(e, 'showLinkedIn')} />
                            </div>

                            <div className="btn btn-link text-start">
                                <Switch text={this.context.lang.marriage}
                                    icon={<i class="las la-ring"></i>}
                                    defaultChecked={this.state.cv.showMarriage}
                                    onChange={e => this.onContentEditableChange(e, 'showMarriage')} />
                            </div>

                            <div className="btn btn-link text-start">
                                <Switch text={t("militaryService")}
                                    icon={<i class="las la-fighter-jet"></i>}
                                    defaultChecked={this.state.cv.showMilitaryService}
                                    onChange={e => this.onContentEditableChange(e, 'showMilitaryService')} />
                            </div>

                            <div className="btn btn-link text-start">
                                <Switch text={this.context.lang.summery}
                                    defaultChecked={this.state.cv.showSummery}
                                    onChange={e => this.onContentEditableChange(e, 'showSummery')} />
                            </div>
                        </Dropdown>
                    </div>

                    {this.context.getCurrentUser() ?
                        <Dropdown ref={e => this.userMenuContainer = e}
                            title={<><i class="las la-user-circle"></i> <b>{this.context.getCurrentUser()?.userName}</b></>}
                            className="btn btn-outline-dark btn-sm me-1 bg-white2 "
                            style={{ left: '45px', width: '200px' }} >

                            {this.state.myResumes.map((x, i) =>
                                <div style={{ minWidth: '200px' }}>
                                    <button onClick={() => this.openResume(x.id)} key={i} className="btn btn-link text-start" style={{ width: '79%', maxWidth: '166px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                        <i className="lab la-wpforms float-start" style={this.style.las}></i>{x.title}
                                    </button>
                                    <button
                                        onClick={() => this.removeResume(x.id)}
                                        className="btn btn-link text-danger float-end"><i class="las la-trash "></i></button>
                                </div>
                            )}
                            <hr style={{ margin: '0.1rem 0' }} />
                            <button onClick={() => this.signOut()} className="btn btn-link text-start"><i className="las la-sign-out-alt float-start" style={this.style.las}></i>Log out</button>
                        </Dropdown> :
                        <div className="user-btn">
                            <button onClick={() => { this.setState({ openLoginModal: true }) }} className="btn btn-outline-dark btn-sm me-1 bg-white2 ">{this.context.lang.login}<i className={icons.signIn}></i></button>
                        </div>
                    }

                    <div style={{ display: 'inline-flex' }} className="selector2">
                        


                    </div>


                    <div><i></i></div>

                    <div className="d-inline-flex">

                        <button onClick={() => { this.setState({ openFeedBackModal: true }) }} className="btn btn-outline-dark btn-sm me-1 bg-white2 ">{this.context.lang.feedBackMnu}<i className={icons.comment}></i></button>


                        <button onClick={() => { this.setState({ openSetting: !this.state.openSetting }) }} className="btn btn-outline-dark btn-sm ms-1 bg-white2 d-xl-none setting-div-btn me-1"><i className={icons.cog}></i></button>

                        <div style={{ direction: this.context.lang == lang.farsi ? 'rtl' : 'ltr' }} className="lang-div">
                            {/*<span className="d-none d-sm-inline">{t("lang")} {CvMakerContext._currentValue.lang.ـlangName}</span>*/}
                            <select value={this.context.lang._langName}
                                onChange={(e) => {
                                    this.context.toggleLanguage(e.target.value);
                                    let old = this.state.templateIndex
                                    this.setState({ templateIndex: 0 }, () => {
                                        this.setState({ templateIndex: old }, () => { this.setTemplate(); });
                                    });
                                }}
                                style={{ padding: '4px 8px', background: 'white', borderRadius: '5px' }} >
                                {['English', 'فارسی', '日本'].map((x, i) => <option value={x} key={i} selected={this.context.lang.ـlangName == x}>{x}</option>)}
                            </select>
                        </div>


                    </div>

                </div>



                <div className="noPrint" style={{ position: 'fixed', zIndex: '1', top: 70, left: 30 }}>
                    <input step="10" type="range" min="10" max="160"
                        value={this.state.zoom} onChange={(e) => this.setState({ zoom: e.target.value })} />
                    <small>{Math.round(this.state.zoom)}%</small>

                    {/*<button
                        className={`btn btn-sm ms-2 d-md-inline d-none ${!this.state.contenteditableIsFocused ? 'btn-primary' : 'btn-link text-gray'}`}
                        onClick={() => this.setState({ contenteditableIsFocused: !this.state.contenteditableIsFocused })}
                    ><i className="las la-hand-pointer"></i></button>*/}
                </div>

                {/*<button className="float-end" onClick={() =>this.translate() }>trans</button>*/}

                <div className="row mx-0" style={{ minHeight: '100vh', background: 'radial-gradient(rgb(215, 224, 234) 18.75%, transparent 0px) 2px 2px / 10px 10px rgb(236, 240, 245)' }}>

                    <div className={`col-xl-9 col-md-12 px-0 cv-panel ${!this.state.contenteditableIsFocused ? 'movable' : ''}`}>
                        {/* <div className="noPrint" style={{
                            height: '.5cm', width: '100%',
                            backgroundImage: 'repeating-linear-gradient(to right, #444cf7, #444cf7 1px, #000000 1px, #000000)',
                            backgroundSize: '1cm',
                            position: 'fixed', top: '45px', zIndex: '1'
                        }}><i></i></div>
                        <div className="noPrint"  style={{
                            width: '.5cm', height: '100%',
                            backgroundImage: 'repeating-linear-gradient(0deg, #444cf7, #444cf7 1px, #000000 1px, #000000)',
                            backgroundSize: '1cm 1cm',
                            position: 'fixed', top: '63px', zIndex: '1', left: 0
                        }}><i></i></div>*/}

                        {
                            this.state.loadingResume ?
                                <div className="p-5 text-center a4 bg-white mt-2 text-primary card"
                                    style={{
                                        marginLeft: 'auto',
                                        marginRight: 'auto',
                                        opacity: '1',
                                        backgroundSize: '29.7cm 29.7cm',
                                        backgroundImage: 'repeating-linear-gradient(0deg, #444cf700, #001eff 2px, #a5a5cc00 0px, #e5e5f700)',
                                        zoom: `${this.state.zoom}%`,
                                        height: 400
                                    }}>
                                    <div className="card__image loading"></div>
                                    <div className="card__title loading"></div>
                                    <div className="card__description loading"></div>
                                    <div className="card__image loading"></div>
                                    <div className="card__image loading"></div>
                                    <div className="card__description loading"></div>
                                </div> :

                                <Draggable
                                    ref={e => this.DraggableCore = e}
                                    disabled={this.state.contenteditableIsFocused}>
                                    <div id="GFG" className={` ${this.state.cv.rtl ? 'rtl' : 'ltr'} a4 bg-white mt-2`}
                                        style={{
                                            marginLeft: 'auto',
                                            marginRight: 'auto',
                                            opacity: '1',
                                            backgroundSize: '29.7cm 29.7cm',
                                            //backgroundImage: 'repeating-linear-gradient(0deg, #444cf700, #001eff 2px, #a5a5cc00 0px, #e5e5f700)',
                                            zoom: `${this.state.zoom}%`,
                                        }}>

                                        <Suspense fallback={<div>Loading...</div>}>    </Suspense>
                                        <ErrorBoundary>
                                            <this.state.selectedTemplate
                                                cv={this.state.cv}
                                                {...this.templateProp} />
                                        </ErrorBoundary>

                                    </div>
                                </Draggable>
                        }
                        <div className="noPrint text-center p-3">
                            iResume  {this.context.lang.version} 0.80
                        </div>
                    </div>

                    <div className={`col-xl-3 headcolor border-start d-xl-block IRANSans ${this.state.openSetting || 'd-none'} setting-div  `} style={{ zIndex: '2' }}>
                        <div className={`setting-div-btn ${this.context.lang.rtl ? 'rtl' : 'ltr'}`}>
                            <button onClick={() => this.setState({ openSetting: false })} className="btn btn-outline-dark btn-sm me-1 bg-white2 d-inline d-xl-none"><i className="las la-times"></i></button>
                            <b>{this.context.lang.cvSetting}</b>
                            <hr className="m-0" />
                            <div className="mx-2 my-2" style={{ direction: this.context.lang == lang.farsi ? 'rtl' : 'ltr' }}>
                                <small >{this.context.lang.theme}:</small>
                                <div className="themes" style={{ columns: 'auto 3' }} >
                                    {this.templates.map((x, i) => <div className={`text-center border rounded overflow-hidden border-2 ${this.state.template == x.id && 'border-primary'}`}>
                                        <img onClick={() =>
                                            this.setState({ templateIndex: x.id }, () => {
                                                debugger;
                                                this.cvTemp.setState({ 'color2': this.cvTemp.defaultColor });
                                                this.handleChange('color2', this.cvTemp.defaultColor);
                                                this.setTemplate();

                                            })}
                                            src={`./${x.avatar}`}
                                            style={{ height: '100px', }} />
                                    </div>)}
                                </div>
                            </div>
                            <div className="btn btn-link text-start mt-3 w-100">
                                <input type="color"
                                    style={{ width: "36px" }}
                                    value={this.state.cv.color2}
                                    onChange={e => this.onContentEditableChange(e, 'color2')} />
                                <label className="ms-1">{this.context.lang.color2}</label>

                                <button
                                    onClick={e => this.setToDefaultColor()}
                                    className="btn btn-sm btn-primary ms-5 py-0 px-1">set to default</button>
                            </div>

                            <div className="btn btn-link text-start w-100">
                                <Switch text={this.context.lang.skillScore}
                                    defaultChecked={this.state.cv.showSkillRating}
                                    onChange={e => this.onContentEditableChange(e, 'showSkillRating')} />
                            </div>

                            <div className="btn btn-link text-start w-100">
                                <Switch text={this.context.lang.languageScore}
                                    defaultChecked={this.state.cv.showLanguageRatting}
                                    onChange={e => this.onContentEditableChange(e, 'showLanguageRatting')} />
                            </div>

                            <div className="btn btn-link text-start w-100">
                                <Switch text={this.context.lang.rightToLeftLanguage}
                                    defaultChecked={this.state.cv.rtl}
                                    onChange={e => this.onContentEditableChange(e, 'rtl')} />
                            </div>



                        </div>
                    </div>
                </div>


                {this.state.openFeedBackModal && <FeedBack title={this.state.title}
                    onClose={() => this.setState({ openFeedBackModal: false })}
                    onAfterFeedBackdone={this.myResumesAsync} />}

                {
                    this.state.openLoginModal &&
                    <Login title={this.state.title}
                        saveCv={this.saveCv}
                        saveToServer={this.saveToServer}
                        onClose={() => this.setState({ openLoginModal: false })}
                        onAfterLogin={this.myResumesAsync} />
                }

                {
                    this.state.openSaveModal &&
                    <SaveDialog title={this.state.title}
                        saveCv={this.saveCv}
                        saveToServer={this.saveToServer}
                        ocClose={() => this.setState({ openSaveModal: false })}
                        onAfterLogin={this.myResumesAsync} />
                }
            </div >
        );
    }
}
